<template>
  <div class="customer-detail">
    <div class="breadcrumb">
      <i class="el-icon-arrow-left"></i>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>客户审核</el-breadcrumb-item>
        <el-breadcrumb-item>审核详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="back">
        <!-- <span style="color: #333333;font-size: 18px;margin-left: 30px;">审核详情</span> -->
        <span class="go-back" @click="goBack">返回</span>
      </div>
      <!-- 客户基础信息 -->
      <BaseInfo></BaseInfo>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import BaseInfo from './component/BaseInfo.vue'

export default {
  name: 'CustomerDetail',
  components: {
    BaseInfo
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  },
}
</script>


<style lang="scss" scoped>
.customer-detail {
  width: 100%;
  background-color: #fff;
  .line {
    width: 100%;
    height: 10px;
    background-color: #f7f7f7;
  }
  .breadcrumb {
    display: flex;
    height: 50px;
    background-color: #ffffff;
    line-height: 50px;
    padding-left: 15px;
    i {
      line-height: 50px;
      margin-left: 15px;
    }
    .el-breadcrumb {
      line-height: 50px;
    }
  }
  .content {
    background-color: #ffffff;
    .back {
      height: 60px;
      background-color: #ffffff;
       border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content:flex-start;
      position: relative;
      span.go-back {
        position: absolute;
         left: 25px;
        color: #2455ce;
        font-size: 16px;
        cursor: pointer;
        top: 20px;
      }
    }
  }
}
</style>
